"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var back_button_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/back_button"));
var BackButtonStore = /** @class */ (function () {
    function BackButtonStore(props) {
        this.component = back_button_1.default;
        this.label = props.label;
        this.onClick = props.onClick;
    }
    return BackButtonStore;
}());
exports.default = BackButtonStore;
